var React = require('react');

function IconChevronRightSlimInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 31L16 16L1 1","fill":"none","stroke":"currentColor","strokeWidth":"1.50001","strokeLinecap":"round","strokeLinejoin":"round","style":{"fill":"none"}}));
}

IconChevronRightSlimInline.defaultProps = {"width":"17","height":"32","viewBox":"0 0 17 32","fill":"none"};

module.exports = IconChevronRightSlimInline;

IconChevronRightSlimInline.default = IconChevronRightSlimInline;
